"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var htmlDecode = function htmlDecode(input) {
  if (!input || input.length === 0) return '';
  var e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes[0].nodeValue;
};
var _default = exports["default"] = htmlDecode;